.advanced-settings{box-shadow:none}.advanced-header-settings{color:#5a42d0}.advanced-settings-content{padding:0 16px 0 0}.checkbox-content{width:330px}.enhanced-settings-spacing{display:flex;flex-direction:column;gap:16px;margin-bottom:16px}
/*# sourceMappingURL=enhanced-point-cloud-settings.component.css.map */
